import DesktopLayout from "@components-shared/desktop/layout/DesktopLayout";
import { HeaderType } from "@data-types/layout/headerTypeEnum";
import { AdministrationSideMenu } from "@features/administration/side-menu/desktop";
import classNames from "classnames";
import React from "react";

interface AdminLayoutWrapperProps {
	children: React.ReactNode;
	isUserSettingsActive?: boolean;
}

export default function AdminLayoutWrapper(props: AdminLayoutWrapperProps) {
	const sideMenuClassName = classNames("l--aside--left", {
		"is-expanded": props.isUserSettingsActive,
	});

	const mainContainerClassName = classNames("l--main l--main--med", {
		"sidebar-left-expanded": props.isUserSettingsActive,
	});

	return (
		<DesktopLayout
			headerType={HeaderType.WITH_SIDEBAR}
			mainClassName={mainContainerClassName}
		>
			<aside className={sideMenuClassName}>
				<AdministrationSideMenu {...props} />
			</aside>
			<section className="l--content l--content--full">
				<div className="l--content__main">{props.children}</div>
			</section>
		</DesktopLayout>
	);
}
